import React, { Component } from 'react'
import Conditions from '../../molecules/conditions'
import * as styles from './search.module.css'

export default class Search extends Component {

  render() {
    return (
      <div className={styles.search}>
        <p className='heading' style={{ marginBottom: `10px` }}>条件から探す</p>
        <p className={styles.lecture}>女優別、コンセプト別にパイズリ作品を紹介！</p>
        <Conditions />
      </div>
    )
  }
}